module.exports = __webpack_public_path__ + "img/admin-capture-accountingcost.664fff52.png";